export type Settled<T> =
    | { status: 'fulfilled'; value: T }
    | { status: 'rejected'; reason: unknown };

/**
 * Promise.allSettled equivalent — this repo's TypeScript version (3.7) predates
 * that API's lib declarations, even though lib.esnext is configured, so this
 * avoids depending on a type that isn't available to the compiler.
 */
export const settleAll = <T>(promises: Promise<T>[]): Promise<Settled<T>[]> =>
    Promise.all(
        promises.map((p) =>
            p
                .then((value): Settled<T> => ({ status: 'fulfilled', value }))
                .catch((reason): Settled<T> => ({ status: 'rejected', reason })),
        ),
    );
